module.exports = __webpack_public_path__ + "media/npc_dota_hero_sniper.977fb249.webm";